import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { Constraints } from '../../constraints/index.js';
import { LeftIconWrap, getInputStyles } from './styles.js';
import mergeDefaultProps from '../../../utils/merge-default-props.js';
import vars from '../../../styles/custom-properties.js';

var _excluded = ["hasError", "hasWarning", "horizontalConstraint", "isPasswordVisible", "leftIcon", "readOnly", "size"];
var defaultProps = {
  horizontalConstraint: 'scale',
  isPasswordVisible: false,
  size: 'l'
};
var PasswordInputInternal = function PasswordInputInternal(props, ref) {
  var propsInternal = mergeDefaultProps(props, defaultProps);
  var hasError = propsInternal.hasError,
      hasWarning = propsInternal.hasWarning,
      horizontalConstraint = propsInternal.horizontalConstraint,
      isPasswordVisible = propsInternal.isPasswordVisible,
      leftIcon = propsInternal.leftIcon,
      readOnly = propsInternal.readOnly,
      size = propsInternal.size,
      rest = _objectWithoutProperties(propsInternal, _excluded);
  var getFontSize = function getFontSize() {
    switch (size) {
      case 's':
        return vars.fontSize12;
      case 'm':
        return vars.fontSize14;
      default:
        return vars.fontSize16;
    }
  };
  var getWrapperStyles = function getWrapperStyles() {
    return css("display:flex;align-items:center;font-size:", getFontSize(), ";" + ("production" === "production" ? "" : ";label:getWrapperStyles;"), "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  };
  return jsx(Constraints.Horizontal, {
    constraint: horizontalConstraint
  }, jsx("span", {
    css: function css() {
      return getWrapperStyles();
    }
  }, leftIcon && jsx(LeftIconWrap, {
    "data-testid": "left-icon-wrap",
    hasError: hasError,
    hasWarning: hasWarning
  }, leftIcon), jsx("input", _extends({
    ref: ref,
    "aria-readonly": readOnly,
    contentEditable: !readOnly
    ,
    css: function css(theme) {
      return getInputStyles(propsInternal, theme);
    },
    readOnly: readOnly,
    type: isPasswordVisible ? 'text' : 'password'
  }, rest))));
};
PasswordInputInternal.displayName = 'PasswordInput';
var PasswordInput = React.forwardRef(PasswordInputInternal);

export { PasswordInput };
//# sourceMappingURL=password-input.js.map
